var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.quotes.length || _vm.isTemporaryResult
        ? _c(
            "q-toolbar",
            {
              staticClass: "top-page-toolbar",
              attrs: { color: "white", "text-color": "grey-9" }
            },
            [
              _c(
                "q-toolbar-title",
                { staticClass: "q-body-2" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-grey-10 no-underline",
                      attrs: {
                        to: {
                          name: "quotes",
                          params: { teamId: _vm.activeTeam.id }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc("quote", 2)) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" / "),
                  _c("span", { staticClass: "text-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("overview")))
                  ])
                ],
                1
              ),
              _c("q-btn", {
                attrs: {
                  icon: "list",
                  color: _vm.type === "list" ? "grey-9" : "grey-5",
                  round: "",
                  dense: "",
                  flat: ""
                },
                on: {
                  click: function($event) {
                    _vm.handleSetViewType("list")
                  }
                }
              }),
              _c("q-btn", {
                attrs: {
                  icon: "view_module",
                  color: _vm.type === "grid" ? "grey-9" : "grey-5",
                  round: "",
                  dense: "",
                  flat: ""
                },
                on: {
                  click: function($event) {
                    _vm.handleSetViewType("grid")
                  }
                }
              }),
              _c("div", {
                staticClass: "vr q-mx-sm",
                staticStyle: { height: "50%" }
              }),
              _c(
                "q-btn",
                {
                  attrs: {
                    label: _vm.$t("filter"),
                    icon: "filter_list",
                    flat: ""
                  }
                },
                [
                  _vm.filterCount > 0
                    ? _c(
                        "q-chip",
                        { attrs: { color: "primary", floating: "" } },
                        [_vm._v(_vm._s(_vm.filterCount))]
                      )
                    : _vm._e(),
                  _c(
                    "q-popover",
                    [
                      _c(
                        "q-list",
                        { attrs: { separator: "", link: "" } },
                        [
                          _c(
                            "q-item",
                            [
                              _c("q-item-side", {
                                attrs: { icon: "local_offer" }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-select", {
                                    attrs: {
                                      options: _vm.quoteStatuses,
                                      placeholder: _vm.$t("quote_status"),
                                      multiple: "",
                                      "hide-underline": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "status", $$v)
                                      },
                                      expression: "filter.status"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c("q-item-side", {
                                attrs: { icon: "calendar_today" }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-datetime", {
                                    staticClass: "q-mr-lg",
                                    attrs: {
                                      value: _vm.filter.startDate,
                                      type: "date",
                                      placeholder: _vm.$t(
                                        "quote_filter_start_date"
                                      ),
                                      format: _vm.$t("date_format"),
                                      "hide-underline": "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function(val) {
                                        _vm.filter.startDate = val
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c("q-item-side", {
                                attrs: { icon: "calendar_today" }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-datetime", {
                                    attrs: {
                                      value: _vm.filter.endDate,
                                      type: "date",
                                      placeholder: _vm.$t(
                                        "quote_filter_end_date"
                                      ),
                                      format: _vm.$t("date_format"),
                                      "hide-underline": "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function(val) {
                                        _vm.filter.endDate = val
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c("q-item-side", { attrs: { icon: "person" } }),
                              _c(
                                "q-item-main",
                                [
                                  _c("q-select", {
                                    attrs: {
                                      options: _vm.userIdFilterOptions,
                                      placeholder: _vm.$t(
                                        "invoice_filter_user_id"
                                      ),
                                      "hide-underline": "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.filter.userId,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "userId", $$v)
                                      },
                                      expression: "filter.userId"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-item",
                            [
                              _c("q-item-side", {
                                attrs: { icon: "contacts" }
                              }),
                              _c(
                                "q-item-main",
                                [
                                  _c("multi-customer-select", {
                                    staticClass: "q-ma-none",
                                    model: {
                                      value: _vm.filter.customer,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "customer", $$v)
                                      },
                                      expression: "filter.customer"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "vr q-mx-sm",
                staticStyle: { height: "50%" }
              }),
              [
                _c("q-btn", {
                  attrs: { label: _vm.$t("export"), flat: "", size: "md" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleExport($event)
                    }
                  }
                }),
                _c(
                  "q-btn",
                  {
                    staticClass: "invoice-toolbar__actions",
                    attrs: {
                      icon: "more_vert",
                      color: "grey-9",
                      flat: "",
                      round: "",
                      dense: ""
                    }
                  },
                  [
                    _c(
                      "q-popover",
                      [
                        _c(
                          "q-list",
                          { staticClass: "no-border", attrs: { link: "" } },
                          [
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  },
                                  { name: "is-user", rawName: "v-is-user" }
                                ],
                                attrs: {
                                  disabled:
                                    _vm.selectedQuotes.length !== 1 ||
                                    _vm.selectedQuotes[0].status.value !==
                                      "draft"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.callIfNotDisabled(
                                      $event,
                                      _vm.handleEdit
                                    )
                                  }
                                }
                              },
                              [
                                _c("q-item-side", { attrs: { icon: "edit" } }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("edit") }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  },
                                  { name: "is-user", rawName: "v-is-user" }
                                ],
                                attrs: { disabled: !_vm.selectedQuotes.length },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.callIfNotDisabled(
                                      $event,
                                      _vm.handleRemove
                                    )
                                  }
                                }
                              },
                              [
                                _c("q-item-side", {
                                  attrs: { icon: "delete" }
                                }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("remove") }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.selectedQuotes.length <= 1
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.callIfNotDisabled(
                                      $event,
                                      _vm.handleExportSelected
                                    )
                                  }
                                }
                              },
                              [
                                _c("q-item-side", {
                                  attrs: { icon: "cloud_download" }
                                }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("export_selected") }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.selectedQuotes.length !== 1
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.callIfNotDisabled(
                                      $event,
                                      _vm.handlePdfDownload
                                    )
                                  }
                                }
                              },
                              [
                                _c("q-item-side", {
                                  attrs: { icon: "cloud_download" }
                                }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("download_pdf") }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  },
                                  { name: "is-user", rawName: "v-is-user" }
                                ],
                                attrs: {
                                  disabled: _vm.selectedQuotes.length !== 1
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.callIfNotDisabled(
                                      $event,
                                      _vm.handleSend
                                    )
                                  }
                                }
                              },
                              [
                                _c("q-item-side", { attrs: { icon: "email" } }),
                                _c("q-item-main", {
                                  attrs: { label: _vm.$t("send_as_mail") }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _vm.quotes.length || _vm.isTemporaryResult
            ? [
                _vm.type === "list"
                  ? [
                      _c(
                        "div",
                        { staticClass: "round-borders no-scroll" },
                        [
                          _c("q-table", {
                            staticClass: "bg-white no-shadow no-border-radius",
                            attrs: {
                              data: _vm.mappedQuotes,
                              columns: _vm.columns,
                              selection: "multiple",
                              selected: _vm.selectedQuotes,
                              "rows-per-page-options": _vm.rowsPerPageOptions,
                              "row-key": "id",
                              pagination: _vm.pagination,
                              loading: !_vm.quotesLoaded,
                              "table-class": "invoice-table",
                              "binary-state-sort": "",
                              grid: ""
                            },
                            on: {
                              "update:selected": function($event) {
                                _vm.selectedQuotes = $event
                              },
                              "update:pagination": function($event) {
                                _vm.pagination = $event
                              },
                              request: _vm.handleRequest
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "body-cell-quote_number",
                                fn: function(props) {
                                  return _c(
                                    "q-td",
                                    { attrs: { props: props } },
                                    [
                                      props.row.status.value !== "draft"
                                        ? _c(
                                            "router-link",
                                            {
                                              staticClass: "router-link",
                                              attrs: {
                                                to: {
                                                  name: "quote",
                                                  params: {
                                                    quote: props.row.id,
                                                    teamId: _vm.activeTeam.id
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    props.row.quote_number
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "router-link",
                                            {
                                              staticClass: "router-link",
                                              attrs: {
                                                to: {
                                                  name: "edit-quote",
                                                  params: {
                                                    quote: props.row.id,
                                                    teamId: _vm.activeTeam.id
                                                  }
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(_vm.$t("draft")) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                }
                              },
                              {
                                key: "body-cell-created_at",
                                fn: function(props) {
                                  return _c(
                                    "q-td",
                                    { attrs: { props: props } },
                                    [
                                      _c(
                                        "span",
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                props.row.created_at_text
                                              ) +
                                              "\n\n                "
                                          ),
                                          _c(
                                            "q-tooltip",
                                            {
                                              attrs: {
                                                anchor: "top middle",
                                                self: "bottom middle",
                                                delay: 300,
                                                offset: [0, 5]
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    props.row.created_at_date
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }
                              },
                              {
                                key: "body-cell-status",
                                fn: function(props) {
                                  return _c(
                                    "q-td",
                                    { attrs: { props: props } },
                                    [
                                      _c("status-chip", {
                                        attrs: {
                                          status: props.row.status.value,
                                          color: props.row.status.color,
                                          clickable: _vm.user.isUserOfActiveTeam(),
                                          committed:
                                            props.row.committed_at !== null,
                                          small: ""
                                        },
                                        on: {
                                          cancel: function($event) {
                                            _vm.handleCancelQuote(props.row.id)
                                          },
                                          accepted: function($event) {
                                            _vm.handleMarkQuoteAsAccepted(
                                              props.row.id
                                            )
                                          },
                                          open: function($event) {
                                            _vm.handleMarkQuoteAsOpen(
                                              props.row.id
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }
                              },
                              {
                                key: "body-cell-actions",
                                fn: function(props) {
                                  return _c(
                                    "q-td",
                                    { attrs: { props: props } },
                                    [
                                      _c(
                                        "q-btn",
                                        {
                                          staticClass: "invoice-row__actions",
                                          attrs: {
                                            icon: "more_vert",
                                            color: "grey-7",
                                            flat: "",
                                            round: "",
                                            dense: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "q-popover",
                                            [
                                              _c(
                                                "q-list",
                                                {
                                                  staticClass: "no-border",
                                                  attrs: { link: "" }
                                                },
                                                [
                                                  props.row.status.value !==
                                                  "draft"
                                                    ? _c(
                                                        "q-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "close-overlay",
                                                              rawName:
                                                                "v-close-overlay"
                                                            }
                                                          ],
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.$router.push({
                                                                name: "quote",
                                                                params: {
                                                                  team:
                                                                    _vm
                                                                      .activeTeam
                                                                      .id,
                                                                  quote:
                                                                    props.row.id
                                                                }
                                                              })
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-item-side", {
                                                            attrs: {
                                                              icon: "visibility"
                                                            }
                                                          }),
                                                          _c("q-item-main", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "display"
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  props.row.committed_at ===
                                                  null
                                                    ? _c(
                                                        "q-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "close-overlay",
                                                              rawName:
                                                                "v-close-overlay"
                                                            }
                                                          ],
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.$router.push({
                                                                name:
                                                                  "edit-quote",
                                                                params: {
                                                                  team:
                                                                    _vm
                                                                      .activeTeam
                                                                      .id,
                                                                  quote:
                                                                    props.row.id
                                                                }
                                                              })
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-item-side", {
                                                            attrs: {
                                                              icon: "edit"
                                                            }
                                                          }),
                                                          _c("q-item-main", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "edit"
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  props.row.status.value !==
                                                  "draft"
                                                    ? _c(
                                                        "q-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "close-overlay",
                                                              rawName:
                                                                "v-close-overlay"
                                                            }
                                                          ],
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.handlePdfDownload(
                                                                props.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-item-side", {
                                                            attrs: {
                                                              icon:
                                                                "cloud_download"
                                                            }
                                                          }),
                                                          _c("q-item-main", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "download_pdf"
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  props.row.status.value !==
                                                  "draft"
                                                    ? _c(
                                                        "q-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "close-overlay",
                                                              rawName:
                                                                "v-close-overlay"
                                                            }
                                                          ],
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.$router.push({
                                                                name:
                                                                  "create-invoice",
                                                                params: {
                                                                  team:
                                                                    _vm
                                                                      .activeTeam
                                                                      .id
                                                                },
                                                                query: {
                                                                  quote:
                                                                    props.row.id
                                                                }
                                                              })
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-item-side", {
                                                            attrs: {
                                                              icon: "receipt"
                                                            }
                                                          }),
                                                          _c("q-item-main", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "create_invoice"
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  props.row.status.value !==
                                                  "draft"
                                                    ? _c(
                                                        "q-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "close-overlay",
                                                              rawName:
                                                                "v-close-overlay"
                                                            },
                                                            {
                                                              name: "is-user",
                                                              rawName:
                                                                "v-is-user"
                                                            }
                                                          ],
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.handleSend(
                                                                props.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-item-side", {
                                                            attrs: {
                                                              icon: "email"
                                                            }
                                                          }),
                                                          _c("q-item-main", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "send_as_mail"
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "q-item",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "close-overlay",
                                                          rawName:
                                                            "v-close-overlay"
                                                        },
                                                        {
                                                          name: "is-user",
                                                          rawName: "v-is-user"
                                                        }
                                                      ],
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.handleCopy(
                                                            props.row
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("q-item-side", {
                                                        attrs: {
                                                          icon: "file_copy"
                                                        }
                                                      }),
                                                      _c("q-item-main", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "duplicate"
                                                          )
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  props.row.status.value ===
                                                  "draft"
                                                    ? _c(
                                                        "q-item",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "close-overlay",
                                                              rawName:
                                                                "v-close-overlay"
                                                            },
                                                            {
                                                              name: "is-user",
                                                              rawName:
                                                                "v-is-user"
                                                            }
                                                          ],
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.handleRemove(
                                                                props.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-item-side", {
                                                            attrs: {
                                                              icon: "delete"
                                                            }
                                                          }),
                                                          _c("q-item-main", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "delete"
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  props.row.committed_at ===
                                                    null &&
                                                  props.row.status.value !==
                                                    "draft"
                                                    ? [
                                                        _c("q-item-separator"),
                                                        _c(
                                                          "q-item",
                                                          {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "close-overlay",
                                                                rawName:
                                                                  "v-close-overlay"
                                                              },
                                                              {
                                                                name: "is-user",
                                                                rawName:
                                                                  "v-is-user"
                                                              }
                                                            ],
                                                            nativeOn: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.handleCommit(
                                                                  props.row
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("q-item-side", {
                                                              attrs: {
                                                                icon: "lock"
                                                              }
                                                            }),
                                                            _c("q-item-main", {
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "commit"
                                                                )
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm.type === "grid" && _vm.quotes.length
                  ? [
                      _c(
                        "q-infinite-scroll",
                        { attrs: { handler: _vm.handleFetchNextChunk } },
                        [
                          _c(
                            "div",
                            { staticClass: "row gutter-sm q-mt-sm" },
                            _vm._l(_vm.quotes, function(quote) {
                              return _c(
                                "div",
                                {
                                  key: quote.id,
                                  staticClass:
                                    "col-xs-12 col-sm-6 col-md-4 col-xl-3"
                                },
                                [
                                  _c("quote-card", {
                                    attrs: { quote: quote },
                                    on: {
                                      select: function($event) {
                                        _vm.handleSelect(quote, $event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            })
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.showEmptyState
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-pt-lg"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("assets/emptystates/invoices_empty.svg")
                          }
                        }),
                        _c("h6", { staticClass: "q-my-md text-faded" }, [
                          _vm._v(_vm._s(_vm.$t("quotes_empty")))
                        ]),
                        _c(
                          "q-btn",
                          {
                            staticClass: "q-mt-lg",
                            attrs: { color: "primary", outline: "" },
                            on: { click: _vm.handleCreateQuote }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("create_quote")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "q-page-sticky",
        { attrs: { position: "bottom-right", offset: [18, 18] } },
        [
          _c(
            "q-btn",
            {
              directives: [{ name: "is-user", rawName: "v-is-user" }],
              staticClass: "add-invoice__button",
              attrs: { color: "primary", round: "", fab: "" },
              on: {
                click: function($event) {
                  _vm.$router.push({ name: "create-quote" })
                }
              }
            },
            [_c("q-icon", { attrs: { name: "add" } })],
            1
          )
        ],
        1
      ),
      _c("quote-export-modal", { ref: "quoteExportModal" }),
      _c("quote-send-modal", { ref: "quoteSendModal" }),
      _c("success-modal", {
        ref: "successModal",
        attrs: {
          title: _vm.$t("export_successful_title"),
          body: _vm.$t("export_successful_body")
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }